import FeatureGates from '@atlaskit/feature-gate-js-client/feature-gates';

const SALESFORCE_STAGE_FILTER_TARGET_APPS: ReadonlySet<string> = new Set([
	'atlas_server',
	'atlas_web',
	'confluence_server',
	'confluence_web',
	'jira_server',
	'jira_web',
	'rovo-extension_web',
	'rovo_web',
]);

export const isSalesforceStageFilterSupportedInCurrentApp = (): boolean => {
	// Some SDK clients and product test mocks do not implement getTargetApp.
	const targetApp = FeatureGates.getTargetApp?.();
	return targetApp !== undefined && SALESFORCE_STAGE_FILTER_TARGET_APPS.has(targetApp);
};
